import React from 'react';
import {
    Box,
    Center,
    Spinner,
    Text,
    VStack,
    useColorModeValue,
} from '@chakra-ui/react';

interface LoadingOverlayProps {
    isVisible: boolean;
    message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
    isVisible,
    message = 'Memuat data produksi...'
}) => {
    const bgColor = useColorModeValue('rgba(255,255,255,0.9)', 'rgba(26,32,44,0.9)');
    const textColor = useColorModeValue('gray.700', 'gray.200');

    if (!isVisible) return null;

    return (
        <Center
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg={bgColor}
            zIndex={9999}
            backdropFilter="blur(2px)"
        >
            <VStack spacing={4}>
                <Spinner
                    thickness="4px"
                    speed="0.65s"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="xl"
                />
                <Text 
                    fontSize="lg" 
                    color={textColor}
                    fontWeight="medium"
                    textAlign="center"
                >
                    {message}
                </Text>
            </VStack>
        </Center>
    );
};

export default LoadingOverlay;
